import React from "react";
import "./TermsAndConditon.scss";
import TAConditionCTA from "./TAConditionCTA";
import { PRIMARY_SOURCE } from "../../../../config/constant";

const TAConditionProvidentLandProjects = ({
  isPreview,
  handlePrevious,
  primarySource,
  projectName
}) => {
  return (
    <div
      className={`TermsWrapper ${
        isPreview ? "applicantDetailsCard previewColor" : ""
      }`}
    >
      {isPreview ? (
        <h3 className="titlePersonalHD marginBottom16">Terms & Conditions</h3>
      ) : (
        <div className="titleTerms">Terms & Conditions</div>
      )}
      <div className="titleTermsBig">
        I HAVE READ AND UNDERSTOOD AND AGREE TO THE TERMS OF PAYMENT STATED
        BELOW:
      </div>
      <div className="tbResponsive">
        <table>
          <tr>
            <th>DAY/EVENT</th>
            <th>PAYMENT OBLIGATION</th>
            <th>CONDITIONS</th>
          </tr>
          <tr>
            <td>Day 1/Date of submitting booking form</td>
            <td>'2,00,000' (Rupees Two Lakhs, inclusive of applicable GST)</td>
            <td>REFUNDABLE</td>
          </tr>
          <tr>
            <td>Within 3 (three) days of issue of allotment letter.</td>
            <td>
              9.9% of the agreement value, excluding amounts already paid.
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Execution and registration of agreement to sell</td>
            <td>
              11.1% of the agreement value, excluding amounts already paid.
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="3" align="center">
              IF PROVISIONAL ALLOTMENT IS CANCELLED IN ACCORDANCE WITH THE TERMS
              CONTAINED HEREIN, PROMOTER IS ENTITLED TO ALLOT THE CANCELLED
              APARTMENT TO ANY THIRD PARTY AT ITS SOLE DISCRETION. THE
              APPLICANT(S) WILL THEREAFTER HAVE NO FURTHER RIGHTS OR CLAIMS
              AGAINST THE COMPANY FOR ALLOTMENT/POSSESSION OF THE CANCELLED
              APARTMENT.
            </td>
          </tr>
          <tr>
            <td colSpan="3" align="center">
              EXCEPT FOR GST ON BOOKING AMOUNT, APPLICABLE GOODS AND SERVICES
              TAX, INFRASTRUCTURE CHARGES, STATUTORY DUTIES, FEES AND LEVIES &
              OTHER POSSESSION RELATED CHARGES ARE NOT INCLUDED AND IS PAYABLE
              AS PER COST SHEET PROVIDED OR PAYMENT SCHEDULE ATTACHED TO THE
              SALE AGREEMENT.
            </td>
          </tr>
        </table>
      </div>

      <div className="titleTermsBig marginBottom">
        TERMS AND CONDITIONS OF THE APPLICATION FOR ALLOTTMENT
      </div>
      <div className="tbResponsive">
        <table>
          <tr>
            <th>SL.NO.</th>
            <th align="center">HEADING</th>
            <th align="center">IMPORTANT TERMS & CONDITIONS</th>
          </tr>

          <tr>
            <td valign="top">1</td>
            <td valign="top">
              <b>Application not a confirmation of allotment</b>
            </td>
            <td>
              It is expressly clarified that this application for allotment (the
              "<b>Application</b>") is neither a confirmation of allotment nor
              an express or implied undertaking by the {projectName?.includes("Ecopolitan") ? "Provident White Oaks LLP" : "Provident Housing Limited"}. 
              And/or its subsidiaries, affiliates, associated concerns
              (the "<b>Promoter</b>") to allot and/or reserve and/or block the
              unit that the applicant(s) has expressed a preference for, in this
              Application.
              <br /> If the Application is confirmed,the unit chosen and
              preferred by the customer(the "<b>Unit</b>")will be {""}
              <u>
                <b>
                  temporarily blocked and an allotment letter will be
                  issued,subject to the explicit conditions set out in paragraph
                  4 below,
                </b>
              </u>
              failing which the company shall be entitled to cancel the
              allotment and deal with the unit in any manner of its choosing.
            </td>
          </tr>
          <tr>
            <td valign="top">2</td>
            <td valign="top">
              <b>Basis of processing Application</b>
            </td>
            <td>
              Application will be considered and processed by Promoter in
              accordance with its policies and procedures, including but not
              limited to carrying out the necessary checks to establish the
              credentials and financial and credit score of the Applicant(s).
            </td>
          </tr>
          <tr>
            <td valign="top">3</td>
            <td valign="top">
              <b>Application not a confirmation of allotment</b>
            </td>
            <td>
              Document to be {" "}
              <u>
                <b>mandatorily</b>
              </u>
              &nbsp;
              <u>
                <b>submitted</b>
              </u>
              {" "} along with the Application:
              <ul>
                <li>
                  (i) Self-attested copy of Applicant(s) {" "}
                  <u>
                    <b>PAN card;</b>
                  </u>
                </li>
                <li>
                  (i) Self-attested {" "}
                  <b>
                    <u>proof of residence</u>
                  </b>
                  {" "}of Applicant(s);
                </li>
                <li>
                  (i) Self-attested {" "}
                  <b>
                    <u>proof of age</u>
                  </b>
                  of Applicant(s).
                </li>
              </ul>
              If the application is in joint names, both the applicants must
              sign the application form and submit necessary documents.
            </td>
          </tr>
          <tr>
            <td valign="top">4</td>
            <td valign="top">
              <b>Conditions of Allotment</b>
            </td>
            <td>
              The allotment, if confirmed pursuantto this Application, is
              subject to the following conditions:
              <ul>
                <li>
                  (i) the allotment shall always be subject to the scheme and
                  design of development formulated by Promoter for this project,
                  which cannot be changed except in accordance with law; and
                </li>
                <li>
                  (ii) the allotment shall not be transferred/assigned except
                  with the written consent of Promoter, which Promoter is
                  entitled to deny; and always subject to the terms and
                  conditions of transfer/assignment specified by Promoter; and
                </li>
                <li>
                  (iii) that if Applicant(s) fails to execute the agreement to
                  sell within 30 (thirty) days from the date of issue of the
                  Allotment Letter; <b>and</b> Applicant fails present
                  himself/herself/themselves before the jurisdictional
                  sub-registrar for registration of the agreement to sell within
                  90 (ninety) days from the date of issue of the allotment
                  letter;<b>and</b> Applicant(s) makes full payment of not less
                  than 20% of the sale consideration within 75 (seventy five)
                  days from the date of issue of the Allotment Letter, the unit
                  temporarily reserved/blocked for the Applicant will be
                  released, without the need for any further notice to
                  Applicant(s), and the allotment in favour of
                  Applicant(s)stands cancelled with immediate effect.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td valign="top">5</td>
            <td valign="top">
              <b className="powerOfAttorney">Powers of Attorney</b>
            </td>
            <td>
              In case Applicant(s) appoints a power of attorney, a self-attested
              copy of the power of attorney must be submitted along with this
              Application, failing which Promoter may reject the Application.
              <br /> If the Applicant(s) is desirous of appointing a power of
              attorney for execution and registration of the agreement to sell,
              Promoter may, upon a request from Applicant, assistthe Applicant
              in such process, the costs, expenses and charges of which shall be
              borne by the Applicant(s).
            </td>
          </tr>
          <tr>
            <td valign="top">6</td>
            <td valign="top">
              <b>Additional Parking Spaces</b>
            </td>
            <td>
              If additional parking spaces are available or become available in
              the future, any allotment of such additional car parks may be made
              by the Promoter, on a first come first serve basis and subject to
              receiving a written request from Applicant(s), in line with the
              chronological order in which the agreements to sell were executed
              and registered and Applicant(s) pays not less than 20% of the
              agreed sale consideration. The exact location of the car parking
              space will be determined by the Promoter.
            </td>
          </tr>
          <tr>
            <td valign="top">7</td>
            <td valign="top">
              <b>Time is of the Essence</b>
            </td>
            <td>
              The Applicant(s)undertakes to make payment of any and all amounts
              due to Promoter strictly in accordance with the payment schedule
              stated herein, without delay, and in full. The Applicant(s) agrees
              and acknowledges that, subject to confirmation of allotment, time
              is the essence of the agreement between Applicant(s) and Promoter,
              and consequently the Applicant(s) obligation to make payments on
              time and in full is of the essence.
            </td>
          </tr>
          <tr>
            <td valign="top">8</td>
            <td valign="top">
              <b>Deposits, Charges, Fees and Other Expenses</b>
            </td>
            <td>
              All deposits, fees, expenses, charges or levies including those
              demanded, or incurred, or required to be paid to the relevant
              authorities, bodies, agencies, and/or departments on account of
              developing infrastructure, management of such infrastructure &
              other services shall be borne and paid by the applicant(s) in
              accordance with the terms of the agreement to sell.
            </td>
          </tr>
          <tr>
            <td valign="top">9</td>
            <td valign="top">
              <b>Default & Cancellation</b>
            </td>
            <td>
              Any default in payments by Applicant(s) to Promoter after issue of
              the allotment letter will be handled in accordance with the terms
              and conditions of the allotment letter or executed agreement to
              sell as applicable. In case of the applicant cancelling or seeking
              cancellation of the booking/allotment, prior to execution of
              agreement to sale, booking amount paid will be refunded. Any taxes
              paid to the government will not be refunded.
              <hr />
              The applicant/s will be solely responsible for timely payment of
              all amounts due, irrespective of whether the payments are made
              from their own funds or by way of housing loan if any availed from
              a bank.
            </td>
          </tr>
          <tr>
            <td valign="top">10</td>
            <td valign="top">
              <b>GST</b>
            </td>
            <td>
              In the event of cancellation of an allotment for any reasons
              whatsoever, all amounts paid on account of Goods and Services Tax
              cannot be refunded. The Company will provide a certificate to the
              applicant stating the amounts paid on account of GST, which
              certificate the applicant may use to directly apply for refund of
              GST paid, if permitted by law.
            </td>
          </tr>
          <tr>
            <td valign="top">11</td>
            <td valign="top">
              <b>Change Management</b>
            </td>
            <td>
              In case the applicant/s is desirous of changing/substituting the
              names of purchasers/applicants after the execution and
              registration of the agreement to sell, all charges, costs and
              expenses associated therewith, including but not limited to
              procuring, embossing, franking of relevant document and purchase
              of stamp papers shall be borne exclusively by the applicant(s).
            </td>
          </tr>
          <tr>
            <td valign="top">12</td>
            <td valign="top">
              <b>Minor Applicant</b>
            </td>
            <td>
              Wherever a minor is a second applicant, all documents shall be
              signed by the natural guardian on behalf of the minor. The natural
              guardian shall be solely responsible for informing the Company
              once the minor attains the age of majority, and at all times prior
              to the execution of the conveyance deed.
            </td>
          </tr>
          <tr>
            <td valign="top">13</td>
            <td valign="top">
              <b>Governing Law</b>
            </td>
            <td>
              All disputes relating to/arising out of or in relation to this
              application for allotment will be subject to the exclusive
              jurisdiction of the courts located in the city where the project
              is situated.
            </td>
          </tr>
        </table>
      </div>
      {primarySource === PRIMARY_SOURCE?.PurvaPrivilege ? (
        <div className="referralProgramTerms">
          <ol className="ListNumber">
            <li>
              <b className="liB">REFERRAL PROGRAM</b>
            </li>
          </ol>

          <ol className="ListNumber">
            <li>
              1. {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} is a program offered by {projectName?.includes("Ecopolitan") ? "Provident Housing Limited" : "Puravankara Limited"}.
              exclusively for home owners in {projectName?.includes("Ecopolitan") ? "Provident Housing Limited" : "Puravankara Limited"}. projects or
              projects developed by its subsidiary companies.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              2. The applicant is required to submit this Referral Registration
              Form, when they wish to refer any interested person to buy a
              property in any {projectName?.includes("Ecopolitan") ? "Provident " : "Puravankara"} Projects.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              3. Existing owners who approach the Company through Brokers, Real
              Estate Agents and Channel Partners of {projectName?.includes("Ecopolitan") ? "Provident " : "Puravankara"} are not eligible
              to participate in this scheme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              4. Any referral registered by an existing owner will be valid for
              only 90 days and shall lapse unless extended by the company, or
              upon receipt of an extension from by the referrer/ applicant. Any
              sale closed, thereafter is not entitled to any referral benefit.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              5. Once a referral is registered with complete details of the
              interested person, the sales team shall do the needful in
              converting the sale and update the status to the referrer. The
              referrer is eligible for referral benefit only after Agreement for
              Sale and Construction Agreement are executed by such customer
              along with payment of 15% of the sale value. 15% payment for
              ongoing and ready to move in projects.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              6. The referral benefit shall be restricted to 2% (1% to referrer
              and 1% to referee) of the Basic Cost of the apartment excluding
              taxes and other charges, in the form of Privilege Points. The
              Privilege points shall be credited within 45 days, post 15% of
              payment towards the unit. For self-purchase, up-to 2 % of the
              Basic Cost of the unit excluding taxes and other charges, will be
              paid in the form of Privilege points. The referral points so
              credited to the referee's {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} account can be redeemed
              through {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} website {" "}
              {projectName?.includes("Ecopolitan")?
              <a href="https://www.providentpremier.com/" target="_blank">
                (www.providentpremier.com)
              </a> :
              <a href="https://www.purvaprivilege.com/" target="_blank">
                (www.purvaprivilege.com)
              </a>}
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              7. The disputes arising out of this policy between the applicant
              and the sales team shall be referred to arbitration by the Head of
              Customer Experience & Loyalty Sales whose decision shall be final
              and binding on both parties.
            </li>
          </ol>
        </div>
      ) : null}

      {primarySource === PRIMARY_SOURCE?.ProvidentPremiere ? (
        <div className="referralProgramTerms">
          <ol className="ListNumber">
            <li>
              <b className="liB">REFERRAL PROGRAM</b>
            </li>
          </ol>

          <ol className="ListNumber">
            <li>
              1. Provident Premier is a program offered by Provident Housing
              Limited exclusively to existing and ex-property owners of
              {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"} (“Referrer”), during the currency of
              this programme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              2. Referrers are required to submit a Referral Registration Form,
              as soon as their referred family or friend buy
              Flat/condos/villa/plots property in any {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"}.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              3. Referrers who approach the Company through Brokers, Real Estate
              Agents and Channel Partners of {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"} /
              Puravankara are not eligible to participate in this scheme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              4. Any referral registered by the Referrer on the portal
              (Providentpremier.com) will be valid for only 90 days for that
              referral and shall lapse unless extended by the company, or upon
              receipt of an extension form by the referrer / applicant. In case
              the sale is not concluded within 90 days or such extended time,
              the Referrer will not be entitled to any Referral Rewards.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              5. As soon as a referral is registered on the portal
              (providentpremir.com) with complete details of person interested
              in purchasing an apartment, the Cognizant Office shall do the
              needful in converting the sale and shall update the status to the
              Referrer. The Referrer is eligible for referral rewards in the
              form of points only after Agreement for Sale and Construction
              Agreement are executed by such customer along with 15% of the sale
              value.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              6. The Referral Rewards shall be restricted to 2% of the Basic
              Cost of the apartment (taxes and other charges excluded) which is
              equally distributed between Referrer & Referee. For repeat
              Purchase up-to 2% of Basic Cost of the apartment/ plot as Reward
              Points which can be utilised in the manner provided above.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              7. Rewards are provided in the form of Points – 1 Point is
              equivalent to1 rupees – Subject to change without notice.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              8. Any disputes that may arise in relation to this policy the
              matter shall be referred to arbitration by the Director, Sales and
              Marketing of {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"}, whose decision shall be
              final and binding on the Referrer.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              9. The Reward payable shall stand adjusted against any outstanding
              amount payable under any head to Provident / Puravankara. Balance
              amount if any payable post such adjustment will be adjusted
              against future demands that will be raised by Puravankara/
              Provident.
            </li>
          </ol>
        </div>
      ) : null}

      <div className="blueLine"></div>
      <ol className="ListNumber">
        <li>
          <b className="liB">Declaration by the Applicant/s:</b> I/We have read
          the above terms and conditions of this Application and after reading
          these terms and conditions, undertake that I/we have fully understood
          the contents thereof, have obtained legal advice on the same, and I/we
          expressly agree to strictly abide by and adhere to these terms and
          conditions.
        </li>
      </ol>
      <ol className="ListNumber">
        <li>
          <b className="liB">If Applicant is NRI/PIO:</b> I/We hereby declare
          that I/We confirm that we are non-resident Indian/Person of Indian
          origin and shall comply with all statutory compliances applicable by
          laws and rules in India applicable for purchase of Apartment/s sold by
          the Company. The Company shall not be liable for any non-compliance on
          my/our part, if any.
        </li>
      </ol>

      <div className="textNote">Note:</div>
      <ol className="normalOl marginB-2">
        <li>
          All payments shall be made to the designated bank account of the
          company, details of which will be provided to the applicant(s). Bank
          charges, if applicable, shall be paid by the applicants on actuals.
        </li>
        <li>
          Please refer to our website for further information on the Project. (
          <a href="https://www.providenthousing.com/" target="_blank">
            www.providenthousing.com
          </a>
          )
        </li>

        <li>
          Whilst it is not mandatory, you may consider nominating one of your
          relatives to facilitate easy possession and registration formalities,
          failing which proof of succession will be required. We shall transfer
          the booking/Apartment to such nominee who shall discharge all your
          responsibility.
        </li>
      </ol>

      {!isPreview ? <TAConditionCTA handlePrevious={handlePrevious} /> : null}
    </div>
  );
};

export default TAConditionProvidentLandProjects;
